import { gql } from "urql";
export const GetUploadFilePresignedUrlMutation = gql `
    mutation GetUploadFilePresignedUrl($input: UploadFilePresignedUrlInput!) {
        files {
            createUploadFilePresignedUrl(input: $input) {
                presignedUrl
            }
        }
    }
`;
export const CreateFileRecordMutation = gql `
    mutation CreateFileRecord($input: CreateFileInput!) {
        files {
            createFileRecord(input: $input) {
                fileId
                name
                fileName
                fileType
                fileSize
                mimeType
                isOriginatingOrganization
                isShared
                tags
                createdAt
            }
        }
    }
`;
export const UpdateFileRecordMutation = gql `
    mutation UpdateFileRecord($input: UpdateFileInput!) {
        files {
            updateFileRecord(input: $input) {
                fileId
                name
                fileType
                tags
            }
        }
    }
`;
export const GetPresignedFileDownloadUrlMutation = gql `
    mutation GetPresignedFileDownloadUrl($fileId: String!) {
        files {
            downloadFilePresignedUrl(fileId: $fileId) {
                presignedUrl
            }
        }
    }
`;
export const DeleteFileMutation = gql `
    mutation DeleteFile($fileId: String!) {
        files {
            deleteFile(fileId: $fileId)
        }
    }
`;
